import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";
import { driver } from "./fragments";
export const DRIVERS_DATA_SAVED = gql`
  subscription driversSaved {
    driversSaved {
      driverData {
        documentId
        drivers {
          ...driver
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${driver}
  ${messageHeaders}
`;
